module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/image-6-87948380d5532f1419fb6c482634c594.png";